(function () {
  'use strict';

  if (!document.body) return;

  var isHome = document.body.classList.contains('template-index');
  var isPage = document.body.classList.contains('template-page');
  var enableProductCards = true;

  var bagIcon =
    '<svg class="arthcart-home-add__icon" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path fill="currentColor" d="M7.5 7V6a4.5 4.5 0 0 1 9 0v1h2.25A1.75 1.75 0 0 1 20.5 8.75v10.5A1.75 1.75 0 0 1 18.75 21H5.25A1.75 1.75 0 0 1 3.5 19.25V8.75A1.75 1.75 0 0 1 5.25 7H7.5Zm1.5 0h6V6a3 3 0 0 0-6 0v1Zm-3.25 1.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h13.5a.25.25 0 0 0 .25-.25V8.75a.25.25 0 0 0-.25-.25H5.25Z"/></svg>';

  function openCartDrawer() {
    if (typeof window.arthcartOpenCartDrawer === 'function') {
      window.arthcartOpenCartDrawer();
      return;
    }
    document.body.classList.add('cart-sidebar-show');
  }

  function parseJsonProduct(item) {
    var raw = item.getAttribute('data-json-product');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      try {
        var ta = document.createElement('textarea');
        ta.innerHTML = raw;
        return JSON.parse(ta.value);
      } catch (e2) {
        return null;
      }
    }
  }

  function variantIdFromItem(item) {
    var json = parseJsonProduct(item);
    if (json) {
      var product = json.product || json;
      var variants = product.variants || json.variants || [];
      if (variants.length) {
        var available = variants.find(function (v) {
          return v.available !== false && v.available !== 'false';
        });
        if (available && available.id) return String(available.id);
        var anyAvail = variants.some(function (v) {
          return v.available !== false && v.available !== 'false';
        });
        if (!anyAvail) return '';
      }
    }
    var input = item.querySelector('form input[name="id"], input[name="id"]');
    if (input && input.value) return String(input.value);
    return '';
  }

  function isSoldOut(item) {
    if (item.classList.contains('sold-out')) return true;
    if (item.querySelector('.price--sold-out, .sold-out, .badge--sold-out')) return true;
    var json = parseJsonProduct(item);
    if (!json) return false;
    var product = json.product || json;
    var variants = product.variants || json.variants || [];
    if (!variants.length) return false;
    return !variants.some(function (v) {
      return v.available !== false && v.available !== 'false';
    });
  }

  function hideNativeActions(item) {
    item.querySelectorAll('.card-action, .card-action-bottom, .card-action__group').forEach(function (action) {
      action.classList.add('arthcart-home-action-hidden');
      action.style.setProperty('display', 'none', 'important');
    });
    item.querySelectorAll(
      '.button-quick-shop, .btn-quick-shop, .quick-shop-button, [data-quickshop], [data-quick-shop], .product-card__quick-add, [data-btn-addToCart]'
    ).forEach(function (el) {
      el.classList.add('arthcart-home-action-hidden');
      el.style.setProperty('display', 'none', 'important');
    });
  }

  /* Task 67 — one price line only */
  function cleanCardPrice(item) {
    var priceEl = item.querySelector('.card-price .price');
    if (!priceEl) return;

    var regular = priceEl.querySelector('.price__regular');
    var saleBlock = priceEl.querySelector('.price__sale');
    var hasCompare = !!(saleBlock && saleBlock.querySelector('s, .price__compare s, .price-item--regular'));
    var onSale = priceEl.classList.contains('price--on-sale') || hasCompare;

    if (onSale) {
      priceEl.classList.add('price--on-sale');
      if (regular) {
        regular.style.setProperty('display', 'none', 'important');
        regular.setAttribute('hidden', 'hidden');
        regular.setAttribute('aria-hidden', 'true');
      }
      if (saleBlock) {
        saleBlock.style.setProperty('display', 'flex', 'important');
        saleBlock.removeAttribute('hidden');
      }
    } else if (regular && saleBlock) {
      /* Duplicate "From ₹" when both blocks render same amount */
      var regText = (regular.textContent || '').replace(/\s+/g, ' ').trim();
      var saleLast = saleBlock.querySelector('.price__last, .price-item--sale');
      var saleText = ((saleLast && saleLast.textContent) || saleBlock.textContent || '').replace(/\s+/g, ' ').trim();
      if (regText && saleText && (regText === saleText || saleText.indexOf(regText) !== -1 || regText.indexOf(saleText) !== -1)) {
        saleBlock.style.setProperty('display', 'none', 'important');
        regular.style.setProperty('display', 'block', 'important');
      }
    }

    item.querySelectorAll('.card-price .unit-price').forEach(function (u) {
      u.style.setProperty('display', 'none', 'important');
    });
  }

  function ensureBuyRow(price) {
    var parent = price.parentNode;
    if (!parent) return null;
    if (parent.classList && parent.classList.contains('arthcart-home-buy-row')) {
      return parent;
    }
    var row = document.createElement('div');
    row.className = 'arthcart-home-buy-row';
    parent.insertBefore(row, price);
    row.appendChild(price);
    return row;
  }

  function styleHomeAddButtons(root) {
    if (!enableProductCards) return;
    var scope = root || document;
    scope.querySelectorAll('.product-item').forEach(function (item) {
      /* Task 72 — PDP Related Products owned by pdp script */
      if (
        item.closest('[id*="product-recommendations"]') ||
        item.closest('.halo-recommendations-block') ||
        item.dataset.arthcartRelatedAdd === '1' ||
        item.classList.contains('is-arthcart-related')
      ) {
        return;
      }

      cleanCardPrice(item);
      hideNativeActions(item);

      if (item.dataset.arthcartHomeAdd === '1') {
        if (!item.querySelector('.arthcart-home-add, .arthcart-home-oos')) {
          item.dataset.arthcartHomeAdd = '0';
        } else {
          return;
        }
      }
      if (item.classList.contains('product-item--loadingNoInfo')) return;
      if (item.closest('#halo-cart-sidebar')) return;
      if (item.closest('.productView-details') && !item.closest('.productListing, .products-grid, .quickSearchResults')) {
        return;
      }

      var price = item.querySelector('.card-price');
      if (!price) return;

      if (isSoldOut(item)) {
        item.querySelectorAll('.arthcart-home-add, .arthcart-home-oos').forEach(function (extra) {
          extra.remove();
        });
        var rowOos = ensureBuyRow(price);
        price.classList.add('arthcart-home-price-row');
        var oos = document.createElement('button');
        oos.type = 'button';
        oos.className = 'arthcart-home-add arthcart-home-oos';
        oos.disabled = true;
        oos.setAttribute('aria-label', 'Out of stock');
        oos.innerHTML = '<span>Out of Stock</span>';
        if (rowOos) rowOos.appendChild(oos);
        else price.appendChild(oos);
        item.dataset.arthcartHomeAdd = '1';
        return;
      }

      var variantId = variantIdFromItem(item);
      /* Task 71 — retry later if variant not ready */
      if (!variantId) return;

      item.querySelectorAll('.arthcart-home-add').forEach(function (extra) {
        extra.remove();
      });

      var row = ensureBuyRow(price);
      price.classList.add('arthcart-home-price-row');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'arthcart-home-add';
      btn.setAttribute('aria-label', 'Add to cart');
      btn.innerHTML = bagIcon + '<span>Add</span>';

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (btn.disabled) return;

        var id = variantId || variantIdFromItem(item);
        if (!id) return;

        btn.disabled = true;
        var prev = btn.innerHTML;
        btn.innerHTML = bagIcon + '<span>…</span>';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(id), quantity: 1 }),
          credentials: 'same-origin'
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return res.json();
          })
          .then(function () {
            try {
              if (window.arthcartMixpanel && typeof window.arthcartMixpanel.track === 'function') {
                window.arthcartMixpanel.track('product_added_to_cart', {
                  variant_id: id,
                  quantity: 1,
                  cta_location: 'product_card'
                });
              } else if (window.mixpanel && typeof mixpanel.track === 'function') {
                mixpanel.track('product_added_to_cart', { variant_id: id, quantity: 1, cta_location: 'product_card' });
              }
            } catch (e) {}
            btn.innerHTML = bagIcon + '<span>Added</span>';
            if (typeof window.arthcartOpenCartDrawer === 'function') {
              window.arthcartOpenCartDrawer();
            } else {
              openCartDrawer();
            }
            /* Keep theme cart count/sidebar in sync */
            try {
              if (window.Shopify && typeof Shopify.getCart === 'function') {
                Shopify.getCart(function (cart) {
                  document.querySelectorAll('[data-cart-count]').forEach(function (el) {
                    el.textContent = String(cart.item_count || 0);
                  });
                  if (window.jQuery && window.halo && typeof halo.updateSidebarCart === 'function') {
                    halo.updateSidebarCart(cart);
                  }
                });
              }
            } catch (e) {}
            setTimeout(function () {
              btn.innerHTML = prev;
              btn.disabled = false;
            }, 900);
          })
          .catch(function () {
            btn.innerHTML = prev;
            btn.disabled = false;
          });
      });

      if (row) row.appendChild(btn);
      else price.appendChild(btn);
      item.dataset.arthcartHomeAdd = '1';
    });
  }

  function ensureBrandAutoplay() {
    if (!isHome) return true;
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return false;
    var ready = true;
    var sliders = $('[data-brands-slider]');
    if (!sliders.length) return true;
    sliders.each(function () {
      var $el = $(this);
      if (!$el.hasClass('slick-initialized')) {
        ready = false;
        return;
      }
      if ($el.data('arthcartAutoplay') === 1) return;
      try {
        $el.slick('slickSetOption', 'infinite', true, false);
        $el.slick('slickSetOption', 'autoplaySpeed', 4200, false);
        $el.slick('slickSetOption', 'pauseOnHover', true, false);
        $el.slick('slickSetOption', 'autoplay', true, true);
        $el.slick('slickPlay');
        $el.data('arthcartAutoplay', 1);
      } catch (e) {
        ready = false;
      }
    });
    return ready;
  }

  /* Task 89 / 87 / 96 — backup init if lazy loader missed hero / museum / appreciation sliders */
  function ensureHeroAndReviewSliders() {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return false;
    var ready = true;
    var nextArrow = (window.arrows && window.arrows.icon_next) || '<button type="button" class="slick-next">Next</button>';
    var prevArrow = (window.arrows && window.arrows.icon_prev) || '<button type="button" class="slick-prev">Prev</button>';

    /* Multi-block image-banner carousels (home + pages) */
    $('[data-image-banner-slide]').each(function () {
      var $el = $(this);
      if ($el.hasClass('slick-initialized')) return;
      ready = false;
      try {
        var autoplay = !!$el.data('autoplay');
        var autoplaySpeed = parseInt($el.data('autoplay-speed'), 10) || 4500;
        $el.slick({
          infinite: true,
          speed: 800,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          arrows: !!$el.data('arrows'),
          dots: !!$el.data('dots'),
          fade: true,
          cssEase: 'ease',
          adaptiveHeight: false,
          pauseOnHover: true,
          nextArrow: nextArrow,
          prevArrow: prevArrow,
          rtl: window.rtl_slick
        });
        if (autoplay) $el.slick('slickPlay');
      } catch (e) {}
    });

    /* Gobardhan / smallImg multi-photo carousels (About Us etc.) */
    $('[data-smallImg-slide]').each(function () {
      var $el = $(this);
      if ($el.hasClass('slick-initialized')) return;
      if ($el.children('.img-box').length < 2) return;
      ready = false;
      try {
        $el.slick({
          infinite: true,
          speed: 800,
          autoplay: true,
          autoplaySpeed: 4500,
          arrows: true,
          dots: true,
          fade: true,
          cssEase: 'ease',
          adaptiveHeight: false,
          pauseOnHover: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          nextArrow: nextArrow,
          prevArrow: prevArrow,
          rtl: window.rtl_slick
        });
        $el.slick('slickPlay');
      } catch (e) {}
    });

    if (isHome) {
      $('[data-review-slider]').each(function () {
        var $el = $(this);
        if ($el.hasClass('slick-initialized')) return;
        ready = false;
        try {
          var rows = parseInt($el.data('row'), 10) || 1;
          $el.slick({
            slidesToShow: rows,
            slidesToScroll: 1,
            autoplay: false,
            dots: true,
            arrows: true,
            speed: 800,
            infinite: true,
            adaptiveHeight: false,
            nextArrow: nextArrow,
            prevArrow: prevArrow,
            rtl: window.rtl_slick,
            responsive: [
              { breakpoint: 992, settings: { slidesToShow: 1, arrows: true, dots: true } },
              { breakpoint: 768, settings: { slidesToShow: 1, arrows: true, dots: true } }
            ]
          });
        } catch (e) {}
      });
    }

    var banners = $('[data-image-banner-slide]');
    var smalls = $('[data-smallImg-slide]').filter(function () {
      return $(this).children('.img-box').length >= 2;
    });
    if (banners.length && banners.filter('.slick-initialized').length !== banners.length) return false;
    if (smalls.length && smalls.filter('.slick-initialized').length !== smalls.length) return false;
    return ready;
  }

  /* Task 85 — strip trailing .00 from visible money */
  function stripPriceDecimals(root) {
    var scope = root || document;
    scope.querySelectorAll('.money, .price-item').forEach(function (el) {
      if (!el || el.children.length > 0) return;
      var text = el.textContent || '';
      if (text.indexOf('.00') === -1) return;
      el.textContent = text.replace(/(\d)\.00(?!\d)/g, '$1');
    });
  }

  function init() {
    styleHomeAddButtons(document);
    stripPriceDecimals(document);
    /* Task 91 — one delayed pass (was 900ms + 2500ms) */
    setTimeout(function () {
      styleHomeAddButtons(document);
      stripPriceDecimals(document);
    }, 1200);

    var hosts = document.querySelectorAll(
      '.product-tab-block, .product-block, .productListing, .products-grid, .quickSearchResults, .quickSearchResultsWrap, [data-collection-products]'
    );
    hosts.forEach(function (host) {
      if (host.dataset.arthcartHomeObs === '1') return;
      /* Task 81 — never observe related products (PDP owns those) */
      if (host.closest && (host.closest('[id*="product-recommendations"]') || host.closest('.halo-recommendations-block'))) {
        return;
      }
      if (host.id && host.id.indexOf('product-recommendations') !== -1) return;
      host.dataset.arthcartHomeObs = '1';
      var obs = new MutationObserver(function () {
        if (host._t) clearTimeout(host._t);
        host._t = setTimeout(function () {
          styleHomeAddButtons(host);
          stripPriceDecimals(host);
        }, 320);
      });
      obs.observe(host, { childList: true, subtree: true });
    });

    if (isHome || isPage) {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        var brandsOk = isHome ? ensureBrandAutoplay() : true;
        var heroOk = ensureHeroAndReviewSliders();
        var topPicksOk = isHome ? ensureTopPicksCarousels() : true;
        if ((brandsOk && heroOk && topPicksOk) || tries > 12) clearInterval(timer);
      }, 700);
    }
  }

  /* Task 105 — Top Picks tab carousels: init/refresh when slick is ready */
  function ensureTopPicksCarousels() {
    if (!isHome) return true;
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return false;

    var blocks = document.querySelectorAll('.product-tab-block [data-product-tab-block][data-layout="slider"], .product-tab-block[data-layout="slider"], [data-product-tab-block][data-layout="slider"]');
    if (!blocks.length) {
      blocks = document.querySelectorAll('[data-product-tab-block]');
    }
    if (!blocks.length) return true;

    var ready = true;
    blocks.forEach(function (block) {
      if (block.getAttribute('data-layout') && block.getAttribute('data-layout') !== 'slider') return;
      var active = block.querySelector('.tab-content.active') || block.querySelector('.tab-content');
      if (!active) return;
      var carousel = active.querySelector('.products-carousel');
      if (!carousel) return;

      var $carousel = $(carousel);
      if ($carousel.hasClass('slick-initialized')) {
        try {
          $carousel.slick('slickSetOption', 'adaptiveHeight', false, false);
          $carousel.slick('setPosition');
        } catch (e) {}
        return;
      }

      ready = false;
      try {
        if (window.sharedFunctions && typeof window.sharedFunctions.productBlockSilder === 'function') {
          window.sharedFunctions.productBlockSilder($(active));
        }
      } catch (e) {}
    });

    return ready;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
